import { fontDisplayName } from './fontDisplayName';
import type { FontOption } from './buildFontOptions';

export type FontUploadResolution =
  | { kind: 'existing'; font: FontOption }
  | { kind: 'new'; displayName: string };

/**
 * Решает, что делать с загружаемым файлом шрифта:
 * - если шрифт с таким же именем уже в списке — выбрать существующий (не добавлять дубль);
 * - иначе — добавить как новый.
 */
export function resolveFontUpload(
  fonts: FontOption[],
  fileName: string
): FontUploadResolution {
  const displayName = fontDisplayName(fileName);
  const existing = fonts.find((f) => f.name === displayName);
  if (existing) {
    return { kind: 'existing', font: existing };
  }
  return { kind: 'new', displayName };
}
